<template>
  <div class="page-dialog">
    <el-form
      ref="productForm"
      label-position="right"
      :inline="true"
      size="mini"
    >
      <el-row>
        <el-col :span="8">
          <el-form-item label="销售计划编号">
            <el-input v-model="conditions.planNumber" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="btky-tl">
        <el-button type="default" icon="el-icon-refresh-right" size="mini" @click="reset">重置</el-button>
        <el-button type="primary" size="mini" icon="el-icon-search" :loading="loading" @click="queryData">查询</el-button>
      </el-row>
    </el-form>

    <div class="table-container">
      <TableCommon
        :show-header="false"
        :pagination="pagination"
        @pagination-change="handleTablePaginationChange"
      >
        <vxe-grid
          ref="gridOptions"
          v-loading="loading"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="400"
          align="center"
          size="mini"
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          :empty-render="{name: 'NotData'}"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
          @cell-dblclick="cellClick"
        />
      </TableCommon>
    </div>

  </div>
</template>

<script>
import { getRemReward } from '@/api/sap/reward-policy'
export default {
  props: {
    queryParams: {
      type: Object,
      default: () => {
        return { customerCode: '' }
      }
    },
    isAuth: {
      type: Boolean,
      default: false
    },
    isRadio: {
      type: Boolean,
      default: true
    },
    head:{
      type: Object
    },
    item:{
      type: Object
    },
    allData:{
      type: Array,
      default: () => {
        return []
      }
    },
  },
  data() {
    return {
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      conditions: {
        planNumber: '',
      },
      selectDataOptions: {},
      loading: false,
      gridOptions: {
        columns: [
          { type: 'radio', title: '', filed: 'radio', width: 40 },
          {
            field: 'plan_number',
            title: '销售计划编号',
            width: 120
          },
          {
            field: 'gjahr',
            title: '年度',
          },
          {
            field: 'monat',
            title: '月份',
          },
          // {
          //   field: 'customer',
          //   title: '提报类型',
          // },
          {
            field: 'plan_type_dscr',
            title: '计划类型',
          },
          {
            field: 'wlybrand_name',
            title: '存货分类',
          },
          {
            field: 'total_qty',
            title: '总计划量(件)',
          },
          {
            field: 'initplan_qty',
            title: '初始总计划量(件)',
          },
          {
            field: 'billing_qty',
            title: '已开票计划量(件)',
          },
        ],
        data: []
      }
    }
  },
  computed: {},
  created() {
    if (!this.isRadio) {
      this.gridOptions.columns[0].type = 'checkbox'
      this.gridOptions.columns[0].field = 'checkbox'
    }
    this.queryData()
  },
  methods: {
    cellClick({ row }) {
      if (this.isRadio) {
        this.$refs.gridOptions.setRadioRow(row)
      } else {
      }
    },
    // 查询
    async queryData() {
      this.loading = true
      try {
        const params = {
          mode: 'PROMOTION',
          user_bp: this.$store.getters.role.USER_BP,
          role: this.$store.getters.role.ROLE,
          ...this.pagination,
          head: this.head,
          item: this.allData,
          ...this.conditions
        }
        const res = await getRemReward(params)
        if (res?.msgtype === 'S') {
          this.gridOptions.data = res.data_promotion
          this.pagination.totalCount = +res.total
        }
      } catch (e) {
        //
      }
      this.loading = false
    },
    // 处理分页事件table
    handleTablePaginationChange(pageParams) {
      this.pagination = { ...this.pagination, ...pageParams }
      this.queryData()
    },
    reset() {
      this.conditions = {
        rewardId: '',
        rewardName: ''
      }
    },
    // 用于弹窗提交时 回调数据
    submitForm() {
      // 给父组件返回promise对象用于回调
      if (this.isRadio) {
        const selectData = this.$refs.gridOptions.getRadioRecord()
        if (selectData) {
          console.log(`output->selectData`,selectData)
        }
        return Promise.resolve(selectData)
      } else {
        const selectData = this.$refs.gridOptions.getCheckboxRecords()
        if (selectData.length) {
          selectData.forEach(item => {
            item.productShortName = item.SHORT
            item.productCode = item.PRODUCT_ID
            item.description = item.SHORT_TEXT
            item.brandBqTextView = item.BRAND_BQ_D
            item.containerNum = item.CAPTY
          })
        }
        return Promise.resolve(selectData)
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/reward-policy/components/promotionRewards.vue